import angular from 'angular';

import ScrollIntoViewDirective, { selector } from './scroll-into-view.directive';

export default angular
    .module('application.directive.scroll-into-view', [])
    .directive(selector, ScrollIntoViewDirective);



// WEBPACK FOOTER //
// ./src/application/directive/scroll-into-view/index.js